import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import {
  getEquipmentNameList,
  getApplicableSeviceTypewithIdList,
} from "../Actions/helpersAPI";
import {
  getZoneList,
  getUnitList,
  getVendorList,
} from "../Actions/VendorManagementAPI";
import { getServiceTypeList } from "../Actions/CommonAPI";
import axios from "axios";
import API, { EquipmentList } from "../helpers/api";
import { toast } from "react-toastify";
import { Multiselect } from "multiselect-react-dropdown";
import { getPortAndCountry } from "../Actions/ServiceProviderAPI";
import Autocomplete from "react-autocomplete";
import $ from "jquery";
import swal from "sweetalert";
import 'font-awesome/css/font-awesome.min.css';
let currentuser = JSON.parse(localStorage.getItem("currentUser"));

let searchData = {
  Equipment: "",
  Zone: "",
  country: "",
  port: "",
  VendorName: "",
  PageNumber: 1,
  PageSize: 20,
};
class AddVendor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        EquipmentId: "",
        ZoneId: 0,
        ServiceTypeIds: [],
        ServiceTypeNameList: [],
        UnitId: 0,
        Quantity: "",
        Price: "",
        country: "",
        port: "",
        vendorName: "",
        createdBy: currentuser.email,
      },
      inValidFields: [],
      selectedServiceTypes: [],
      openEquipment: false,
    };
    this.AddVendor = this.AddVendor.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.renderPortTitle = this.renderPortTitle.bind(this);
    this.renderCountryTitle = this.renderCountryTitle.bind(this);
    this.onSelectChange=this.onSelectChange.bind(this);
    this.onRemoveChange=this.onRemoveChange.bind(this);
  }
  componentDidMount() {
    const { dispatch, searchData,VendorNameEdit, EquipmentNameEdit,ZoneNameEdit } = this.props;
    dispatch({ type: "ShowSidePan", data: false });
    dispatch({ type: "SubBannerTitle", data: "Vendor Management" });
    dispatch(getEquipmentNameList());
    dispatch(getApplicableSeviceTypewithIdList());
    dispatch(getServiceTypeList());
    dispatch(getZoneList());
    dispatch(getUnitList());
    if(!VendorNameEdit){
      $("#VendorName").removeAttr("disabled") 
    }
    if(!EquipmentNameEdit){
      $("#exampleFormControlInput1").removeAttr("disabled")  
    }
    if(!ZoneNameEdit){
      $("#ZoneName").removeAttr("disabled") 
    }
    this.state.searchData.vendorName = localStorage.getItem("EditVendorName");
    this.state.searchData.EquipmentId= localStorage.getItem("EditEquipmentNameId");
    this.state.searchData.ZoneId= localStorage.getItem("EditZoneNameId");
    dispatch(getPortAndCountry(this.state.searchData));
  }
  handleInputChange(e, node) {
    const{t}=this.props;
    if (node === "Price") {
      var pattern = /^[0-9]+([.][0-9]+)?$/;
      if (!pattern.test($("#Price").val()) && ($("#Price").val()?.trim() !== "")) {
        $("#PriceErrMsg").text(`${t("ErrorMessage.InvalidMsg")}`);
        let invalid = this.state.inValidFields;
        this.setState({
          invalidFields: invalid.push("Price"),
        });
      } else {
        $("#PriceErrMsg").text("");
        let invalid = this.state.inValidFields;
        let length = this.state.inValidFields.length;
        var index = invalid.indexOf("Price");
        if (index != -1) {
          invalid.splice(index, length);
        }
        this.state.searchData[node] = e.target.value;
        this.setState({ invalidFields: invalid });
      }
    }
    if (node === "Quantity") {
      var pattern = /^(0|[1-9][0-9]*)$/;
      if (!pattern.test($("#Quantity").val())) {
        $("#QuantityErrMsg").text(`${t("ErrorMessage.NumberMsg")}`);
        let invalid = this.state.inValidFields;
        this.setState({
          invalidFields: invalid.push("Quantity"),
        });
      } else {
        $("#QuantityErrMsg").text("");
        let invalid = this.state.inValidFields;
        let length = this.state.inValidFields.length;
        var index = invalid.indexOf("Quantity");
        if (index != -1) {
          invalid.splice(index, length);
        }
        this.state.searchData[node] = e.target.value;
        this.setState({ invalidFields: invalid });
      }
    }
    this.state.searchData[node] = e.target.value;
    this.setState({});
  }
  vendorDetailsValidation() {
    const{t}=this.props;
    let equipment = this.state.searchData.EquipmentId;
    let zone = this.state.searchData.ZoneId;
    let vendorName = this.state.searchData.vendorName;
    let serviceType = this.state.searchData.ServiceTypeIds;
    let unit = this.state.searchData.UnitId;
    let price = this.state.searchData.Price;
    let quantity = this.state.searchData.Quantity;
    let country = this.state.searchData.country;
    let port = this.state.searchData.port;
    if (
      equipment !== "" &&
      zone !== "" &&
      serviceType.length !== 0 &&
      unit !== "" &&
      price !== "" &&
      quantity !== "" &&
      country !== "" &&
      port !== "" &&
      vendorName !== ""
    ) {
      if (this.state.inValidFields.length === 0) {
        this.AddVendor();
      }
    } else {
      swal("Error!", `${t("CommonText.FillAllFieldMsg")}`, "warning");
    }
  }
  AddVendor() {
    const { dispatch,t } = this.props;
    var decimals = this.state.searchData.Price- Math.floor(this.state.searchData.Price);
       console.log(decimals);
       if(decimals===0){
        this.state.searchData.Price=Math.round(this.state.searchData.Price);
        this.setState({})
}
    let data = {
      vendorId: 0,
      vendorName: this.state.searchData.vendorName,
      equipmentName: this.state.searchData.EquipmentId,
      serviceTypeId: this.state.searchData.ServiceTypeIds.toString(),
      zoneId: parseInt(this.state.searchData.ZoneId),
      country: this.state.searchData.country,
      port: this.state.searchData.port,
      createdBy: currentuser.email,
      isDeleted: false,
      modifiedBy: "",
      price: this.state.searchData.Price,
      unitId: parseInt(this.state.searchData.UnitId),
      quantity: parseInt(this.state.searchData.Quantity),
    };
    let url = `${API.postVendor}`;
    axios
      .post(url, data)
      .then((response) => {
        dispatch(getVendorList(searchData));
        this.hideSidePanel();
        toast.success(`${t("CommonText.CommonAdd")}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        dispatch({
          type: "postVendorDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        swal("Error!", "Something went wrong. Please try again.", "warning");
        dispatch({
          type: "postVendorDetailFailure",
          error: "ERROR",
        });
      });
  }
  onSelectChange = (item) => {
    
    this.state.searchData.ServiceTypeIds = [];
    this.state.searchData.ServiceTypeNameList = item;
    if (item && item.length > 0) {
      item.map((val, index) => {
        let servicenames = this.props.applicableServiceTypeList.filter(
          (x) => x.serviceTypes == val
        );
        if (servicenames && servicenames.length > 0) {
          this.state.searchData.ServiceTypeIds.push(servicenames[0].item);
        }
      });
    }
    this.setState({});
  };

  handleSelectChange(value, field) {
    if (field === "EquipmentId") {
      this.state.searchData.EquipmentId = value;
      this.setState({});
    }
    if (field === "country") {
      this.state.searchData[field] = value;
      this.setState({}, () => {
        console.log(this.state.searchData);
      });
      this.props.dispatch(getPortAndCountry(this.state.searchData));
    }
    this.state.searchData[field] = value;
    this.setState({}, () => {
      console.log(this.state.searchData);
    });
  }
  renderCountryTitle(state, val) {
    return state?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderPortTitle(state, val) {
    return state?.port?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderEquipmentTitle(state, val) {
    return (
      state?.toLowerCase().indexOf(val?.toLowerCase()) !== -1
    );
  }
  onRemoveChange(item) {
    
    this.state.searchData.ServiceTypeIds = [];
    this.state.searchData.ServiceTypeNameList = item;
    if (item && item.length > 0) {
      item.map((val, index) => {
        let servicenames = this.props.applicableServiceTypeList.filter(
          (x) => x.serviceTypes == val
        );
        if (servicenames && servicenames.length > 0) {
          this.state.searchData.ServiceTypeIds.push(servicenames[0].item);
        }
      });
    }
    this.setState({});
  }
  render() {
    const {
      serviceTypeList,
      EquipmentNameList,
      zoneList,
      UnitList,
      PortList,
      Loading,
      VendorCountryList,
      VendorNameEdit,
      EquipmentNameEdit,
      ZoneNameEdit,
      t
    } = this.props;
  console.log("serve",serviceTypeList)
    return (
      <div className="full-height">
        <div className="resource-list-auth-date row pt-3 ">
          <div className="col-lg-12">
            <div className="panel-box search-filter-box">
              <div
                className="card mt-2 MM-card-header"
                style={{ backgroundColor: "white" }}>
                <div
                  className="card-body"
                  style={{
                    padding: "0rem",
                    backgroundColor: "#1a3464",
                    color: "white",
                  }}>
                  <h5
                    className="card-title ml-2 mt-2"
                    style={{ color: "092a51" }}>
                    {t("VendorManagementScreenContent.AddVendor")}
                  </h5>
                </div>
              </div>
              <div className="row search-filter-box">
                <div className="col-lg-4">
                  <label className="form-label fontstyle required">
                  {t("VendorManagementScreenContent.VendorName")}
                  </label>
                  <br></br>
                  <input
                    disabled={VendorNameEdit ? "true" : "false"}
                    type="text"
                    className="form-control"
                    name="VendorName"
                    id="VendorName"
                    value={this.state.searchData.vendorName}
                    placeholder={t("VendorManagementScreenContent.VendorName")}
                    onChange={(e) => this.handleInputChange(e, "vendorName")}
                  ></input>
                </div>
                <div className="col-lg-4">
                  <div
                    className="autocomplete-wrappers"
                    style={{
                      zIndex:
                        this.state.openEquipment && !Loading ? 99999 : null,
                    }}
                  >
                    <label className="form-label fontstyle required">
                    {t("ShipEquipmentStatusScreen.Equipment")}
                    </label>
                    <br></br>
                    <Autocomplete
                     contentEditable={ EquipmentNameEdit ? true : false}
                      open={!Loading ? this.state.openEquipment : false}
                      onMenuVisibilityChange={(isOpen) => {
                        this.state.openEquipment = isOpen;
                        this.setState({});
                      }}
   
                      value={this.state.searchData.EquipmentId}
                      inputProps={{ placeholder: `${t("ShipEquipmentStatusScreen.Equipment")}` }}
                      items={EquipmentNameList ?? []}
                      getItemValue={(item) => item}
                      shouldItemRender={this.renderEquipmentTitle.bind(this)}
                      renderInput={(props) => {
                        return (
                          <div className="input-container">
                          <input
                            className="form-control equipment"
                            id="exampleFormControlInput1"
                            disabled={ EquipmentNameEdit ? true : false}
                            {...props}
                          />
                           <span className="dropdown-arrow"><i className="fas fa-chevron-down icon-small1"></i></span>
                          </div>
                        );
                      }}
                      renderMenu={(item) => (
                        <div className="dropdown">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${
                            isHighlighted ? "selected-items" : ""
                          }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChange(e, "EquipmentId")
                      }
                      onSelect={(value, item) =>
                        this.handleSelectChange(value, "EquipmentId")
                      }
                    />
                  </div>
                </div>
                <div className="col-lg-4">
                  <label className="form-label fontstyle required">{t("ZoneScreen.Title")}</label>
                  <br></br>
                  <select
                    className="form-control"
                    name="ZoneId"
                    id="ZoneName"
                    disabled={ZoneNameEdit ? "true" : "false"}
                    value={this.state.searchData.ZoneId}
                    onChange={(e) => this.handleInputChange(e, "ZoneId")}
                  >
                    <option value="">{t("VendorManagementScreenContent.SelectZone")}</option>
                    {zoneList &&
                      zoneList?.map((zonename) => (
                        <option value={zonename.id}>{zonename.value}</option>
                      ))}
                  </select>
                  <span id="ZoneErrMsg" className="spanErrMsg"></span>
                </div>
                <div className="col-lg-4 mt-2">
                  <div className="autocomplete-wrappers">
                    <label className="form-label fontstyle required">
                    {t("EquipmentServiceTypes.Country")}
                    </label>
                    <br></br>
                    <div className="autocompleteiicon">
                    <Autocomplete
                      contentEditable={true}
                      value={this.state.searchData.country}
                      inputProps={{ placeholder: `${t("EquipmentServiceTypes.Country")}` }}
                      items={VendorCountryList ?? []}
                      getItemValue={(item) => item}
                      shouldItemRender={this.renderCountryTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdown">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${
                            isHighlighted ? "selected-items" : ""
                          }`}
                        >
                          {item}
                        </div>
                      )}
                      onChange={(e, field) =>
                        this.handleInputChange(e, "country")
                      }
                      onSelect={(value) =>
                        this.handleSelectChange(value, "country")
                      }
                    />
                     <i className="fas fa-chevron-down icon-small"></i>
                    </div>
                    <span id="CountryErrMsg" className="spanErrMsg"></span>
                  </div>
                </div>
                <div className="col-lg-4 mt-2">
                  <div className="autocomplete-wrappers">
                    <label className="form-label fontstyle required">
                    {t("TopPaneContent.Port")}
                    </label>
                    <br></br>
                    <div className="autocompleteiicon">
                    <Autocomplete
                     
                      contentEditable={true}
                      value={this.state.searchData.port}
                      inputProps={{ placeholder: `${t("TopPaneContent.Port")}` }}
                      items={PortList ?? []}
                      getItemValue={(item) => item.port}
                      shouldItemRender={this.renderPortTitle.bind(this)}
                      renderMenu={(item) => (
                        <div className="dropdown">{item}</div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`items ${
                            isHighlighted ? "selected-items" : ""
                          }`}
                        >
                          {item.port}
                         
                        </div>
                      )}
                      onChange={(e, field) => this.handleInputChange(e, "port")}
                      onSelect={(value) =>
                        this.handleSelectChange(value, "port")
                      }
                    />
                     <i className="fas fa-chevron-down icon-small"></i>
                    </div>
                     
                    <span id="PortErrMsg" className="spanErrMsg"></span>
                  </div>
                </div>
                <div className="col-lg-4 mt-2">
                  <label className="form-label fontstyle required">{t("TopPaneContent.Unit")}</label>
                  <br></br>
                  <select
                    className="form-control"
                    name="UnitId"
                    id="Unit"
                    value={this.state.searchData.UnitId}
                    onChange={(e) => this.handleInputChange(e, "UnitId")}
                  >
                    <option value="">{t("VendorManagementScreenContent.SelectUnit")}</option>
                    {UnitList &&
                      UnitList?.map((unitname) => (
                        <option value={unitname.id}>{unitname.value}</option>
                      ))}
                  </select>
                  <span id="UnitErrMsg" className="spanErrMsg"></span>
                </div>
                <div className="col-lg-4 mt-2">
                  <label className="form-label fontstyle required">
                  {t("ShipEquipmentStatusScreen.Quantity")}
                  </label>
                  <br></br>
                  <input
                    type="text"
                    id="Quantity"
                    className="form-control"
                    name="Quantity"
                    value={this.state.searchData.Quantity}
                    placeholder={t("ShipEquipmentStatusScreen.Quantity")}
                    onChange={(e) => this.handleInputChange(e, "Quantity")}
                  ></input>
                  <span id="QuantityErrMsg" className="spanErrMsg"></span>
                </div>
                <div className="col-lg-4 mt-2">
                  <label className="form-label fontstyle required">
                  {t("content.Servicetype")}
                  </label>
                  <Multiselect
                    options={serviceTypeList ?? []}
                    id="ServiceType"
                    showArrow={true}
                    isObject={false}
                    style={{
                      option: {
                        marginRight: 0,
                        display: "block",
                        fontWeight: "normal",
                      },
                      chips: { "background-color": "#1a3464" },
                    }}
                    onSelect={(item) => this.onSelectChange(item)}
                    onRemove={(item) => this.onRemoveChange(item)}
                    selectedValues={this.state.searchData.ServiceType}
                    placeholder={
                      this.state.searchData.ServiceType &&
                      this.state.searchData.ServiceType.length
                        ? ""
                        : `${t("content.Select")}`
                    }
                    closeIcon="cancel"
                    value={this.state.searchData.ServiceType}
                  />
                  <span id="ServiceTypeErrMsg" className="spanErrMsg"></span>
                </div>
                <div className="col-lg-4 mt-2">
                  <label className="form-label fontstyle required">{t("VendorManagementScreenContent.Price")}</label>
                  <br></br>
                  <input
                    type="text"
                    className="form-control"
                    id="Price"
                    name="Price"
                    value={this.state.searchData.Price}
                    placeholder={t("VendorManagementScreenContent.Price")}
                    onChange={(e) => this.handleInputChange(e, "Price")}
                  ></input>
                  <span id="PriceErrMsg" className="spanErrMsg"></span>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 search-filter-box">
                  <div className="search-btn-col" style={{ textAlign: "end" }}>
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                      type="submit"
                      onClick={() => this.vendorDetailsValidation()}
                    >
                      {" "}
                      {t("ComplianceandBudgetScreen.Submit")}{" "}
                    </button>

                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                      type="button"
                      onClick={() => this.hideSidePanel()}
                    >
                      {" "}
                      {t("ComplianceandBudgetScreen.Cancel")}{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  hideSidePanel() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
   this.props.history.push(`/Home/VendorManagement`);
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    VendorNameEdit: state.VendorManagementReducer.VendorNameEdit,
    EquipmentNameEdit:state.VendorManagementReducer.EquipmentNameEdit,
    ZoneNameEdit:state.VendorManagementReducer.ZoneNameEdit,
    serviceTypeList:
      state.MasterScreenReducer.applicableServiceTypeInterval || [],
    applicableServiceTypeList:
      state.MasterScreenReducer.applicableServiceTypeList || [],
    EquipmentNameList: state.MasterScreenReducer.EquipmentNameList || [],
    zoneList: state.VendorManagementReducer.zoneList,
    UnitList: state.VendorManagementReducer.UnitList,
    showSidePane: state.SidePanReducer.sidePan,
    PortList: state.MasterScreenReducer.PortLists || [],
    VendorCountryList: state.VendorManagementReducer.VendorCountryList || [],
    Loading: state.PageLoaderReducer.loading,
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddVendor)));
